<mat-nav-list>
  @for (action of data; track action) {
    @if (action.visible) {
      <a mat-list-item [style.color]="action.color" [class.disabled]="action.disabled"
        (click)="handleClick({event: $event, action: action.act})">
        <span matListItemTitle>
          <mat-icon style="vertical-align: middle;">{{action.icon}}</mat-icon>
          {{ action.button }}
        </span>
      </a>
    }
  }
</mat-nav-list>
